export enum OccupationType {
  MANAGER = "MANAGER",
  CLERICAL = "CLERICAL",
  LABOURER_OR_TRADESPERSON = "LABOURER_OR_TRADESPERSON",
  RETIRED = "RETIRED",
  PROFESSIONAL = "PROFESSIONAL",
  SELF_EMPLOYED = "SELF_EMPLOYED",
}
